module.exports = __webpack_public_path__ + "img/login-bg1.15240239.png";